import {
  configApiRef,
  createApiFactory,
  createComponentExtension,
  createPlugin,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { PdpFilterClient, pdpFilterRef } from './api';
import { pdpLoggerApiRef } from '@internal/plugin-pdp-logger-frontend';

export const pdpFilterPlugin = createPlugin({
  id: 'pdp-filter-frontend',
  apis: [
    createApiFactory({
      api: pdpFilterRef,
      deps: {
        configApi: configApiRef,
        identityApi: identityApiRef,
        pdpLoggerApi: pdpLoggerApiRef,
      },
      factory: ({ configApi, identityApi, pdpLoggerApi }) =>
        new PdpFilterClient({ configApi, identityApi, pdpLoggerApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
  featureFlags: [],
});

// Dummy page that ensures our plugin gets registered properly.
export const PdpFilterFrontendPage = pdpFilterPlugin.provide(
  createComponentExtension({
    name: 'PdpFilterFrontendPage',
    component: {
      lazy: () =>
        import('./components/PdpFilterFrontendPage').then(
          m => m.PdpFilterFrontendPage,
        ),
    },
  }),
);
